export const SET_DATA = 'baseUrl/SET_DATA';
